import React, {Component} from 'react'
import Draggabilly from 'draggabilly'
import $ from 'jquery';

import BecomeXXLPopup from '../BecomeXXLPopup/index';
import AnonymousLoginPopup from "../AnonymousLoginPopup";
import UserContextMenu from '../UserContextMenu/index';

import MoodPanel from './MoodPanel';
import DonatePanel from '../DonatePanel';
import Registry from '../../../registry/index';
import NotEnoughTokens from './NotEnoughTokens';
import * as VirtualWindowManager from '../VirtualWindowManager/index';

import {
    WINDOW_SMALL,
    WINDOW_MEDIUM,
    WINDOW_LARGE,
    VIEW_WINDOW_RESIZE,
    VIDEO_WINDOW_CLOSE,

    VIDEO_WINDOW_STATE_ONLINE,
    VIDEO_WINDOW_STATE_PAUSED,
    VIDEO_WINDOW_STATE_BLOCKED,
    VIDEO_WINDOW_STATE_OFFLINE,
    VIDEO_WINDOW_STATE_CONNECTING,
    VIDEO_WINDOW_STATE_CONNECTED,
    VIDEO_WINDOW_STATE_OPENED,
    VIDEO_WINDOW_STATE_LIMIT_REACHED
} from '../../../constants/streaming';

class VideoWindow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...this.getBaseState(props),
            sendingTokens: 0,
            videoViewable: false,
            donatePanelShow: false,
            videoWindowHeight: 180,
            notEnoughTokensShow: false,
            soundState: props.videoStream.user.audio ? 'mute' : 'no_sound',
            savedSoundState: 'mute',
            // todo: move to VirtualWindow component
            unmoved: true,
            untouched: true,
            resolution: null
        };

        this.onClick = this.onClick.bind(this);
        this.sizeSwitch = this.sizeSwitch.bind(this);
        this.resizeVideoWindow = this.resizeVideoWindow.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onSoundControlClick = this.onSoundControlClick.bind(this);

        this.onVideoCanplay = this.onVideoCanplay.bind(this);
        this.checkAnonymousBlur = this.checkAnonymousBlur.bind(this);
        this.updateResolution = this.updateResolution.bind(this);
    }

    /**
     * Returns part of VideoWindow's state that could be
     *
     * @param props
     * @return {{}}
     */
    getBaseState(props) {
        let {videoStream, currentUser} = props;

        return {
            size: videoStream.size,
            currentUserBlocked: currentUser.isBeingBlocked(videoStream.user)
        }
    }

    onClick(event) {
        // todo: move to VirtualWindow component
        if (this.state.untouched) this.setState({untouched: false});

        if (this.state.fullscreen) {
            let clickedOutsideVideo = (event.target == this.videoContainer) || (event.target == this.pausedStub);
            if (clickedOutsideVideo) this.collapse();
        }
    }

    onCloseClick() {
        let {videoStream, dispatch} = this.props;

        dispatch({type: VIDEO_WINDOW_CLOSE, stream_id: this.props.streamId});
    }

    onSoundControlClick(event) {
        var targetClassname = event.target.className;

        if (targetClassname.indexOf('no_sound') != -1) {
            return false;
        }

        if (targetClassname.indexOf('sound') != -1) {
            this.setState({soundState: 'mute'});
        }

        if (targetClassname.indexOf('mute') != -1) {
            this.setState({soundState: 'sound'});
        }
    }

    onVideoCanplay() {
        let {dispatch, videoStream} = this.props;
        dispatch({type: 'VIDEO_CANPLAY', ufrag: videoStream.user.ufrag, stream_id: videoStream.stream_id});

        if (this.state.fullscreen) this.onWindowResizeFullscreen();
    }

    onVideoContextMenu(event) {
        event.preventDefault();
        return false;
    }

    sizeSwitch() {
        let {videoStream, dispatch} = this.props;

        switch (this.state.size) {
            case WINDOW_SMALL: dispatch({type: VIEW_WINDOW_RESIZE, stream_id: videoStream.stream_id, size: WINDOW_MEDIUM}); break;
            case WINDOW_MEDIUM: dispatch({type: VIEW_WINDOW_RESIZE, stream_id: videoStream.stream_id, size: WINDOW_LARGE}); break;
            case WINDOW_LARGE: dispatch({type: VIEW_WINDOW_RESIZE, stream_id: videoStream.stream_id, size: WINDOW_SMALL}); break;
        }
    }

    fullscreen() {
        let {currentUser, dispatch, videoStream, browser, setDisableScroll} = this.props;

        if (!currentUser.isAnonymous() && !currentUser.isXXL()) {
            BecomeXXLPopup.open("fullscreen");
        } else {
            dispatch({
                type: 'VIEW_FULLSCREEN',
                stream_id: videoStream.stream_id,
                uid: videoStream.user.uid
            });

            if(browser.mobile && !browser.tablet) {
                setDisableScroll();
                $('.react-swipe-container').css({position: 'static'});
                $('.react-swipe-container > div').css({position: 'static'});
            }
        }
    }

    collapse() {
        let {dispatch, videoStream, browser, setDisableScroll} = this.props;
        
        this.videoContainer.style.top = '';
        this.videoContainer.style.transform = '';
        
        browser.mobile && !browser.tablet ? setDisableScroll() : false;

        dispatch({
            type: 'VIEW_WINDOW',
            stream_id: videoStream.stream_id,
            uid: videoStream.user.uid
        });
    }

    resizeVideoWindow(size) {
        var dims = {
            large: [480, 360],
            medium: [320, 240],
            small: [240, 180]
        };

        if (!dims[size]) return false;

        var $videoWindow = $(this.videoWindow);

        if (this.state.fullscreen) return false;

        var $videoContainer = $(this.videoElement);

        var windowResized = false,
            videoContainerResized = false;

        var onAnimationEnd = function() {
            $videoWindow.find(".fade-effect").show();
            $videoWindow.find(".background-dark").show();
            this.setState({size});
        }.bind(this);

        let {browser} = this.props;

        if (browser.phone && browser.landscape) {
            onAnimationEnd();
            return;
        }

        var animationSpeed = 500,
            windowHeaderHeight = 0;

        var newHeight = dims[size][1];
        var newWidth = dims[size][0];
        var videoWindowNewCss = browser.desktop ? {width: newWidth+"px", height: (windowHeaderHeight+newHeight)+"px"} : {height: newHeight+"px"};

        this.setState({videoWindowHeight: newHeight});

        $videoWindow.find(".fade-effect").hide();
        $videoWindow.find(".background-dark").hide();

        $videoWindow.animate(videoWindowNewCss, animationSpeed, function() {
            $(this).css({width: "", height: ""});
            windowResized = true;
            if (windowResized && videoContainerResized) onAnimationEnd();
        });
        $videoContainer.animate({height: newHeight+"px"}, animationSpeed, function() {
            $(this).css({height: ""});
            videoContainerResized = true;
            if (windowResized && videoContainerResized) onAnimationEnd();
        });
    }

    setPaused(props) {
        let {streamId, videoStream} = props;
        let streamer = videoStream.streamer;
        let stream = videoStream.hitagi_stream;
        let image_url = stream.screenshot ? stream.screenshot : (stream.snapshot ?  stream.snapshot : false);

        if (image_url) {
            $(this.pausedImg).attr('src', image_url);
        }

    }

    onWindowResizeFullscreen() {
        this.videoWindow.style.left = "0px";
        this.videoWindow.style.top = "0px";
        this.videoContainer.style.top = '50%';
        this.videoContainer.style.transform = 'translateY(-50%)';
    }

    onRegisterClick(e) {
        e.preventDefault();

        AnonymousLoginPopup.openAndSwitchTab(1);
    }

    checkAnonymousBlur() {
        let {currentUser, videoStream} = this.props;

        if (!currentUser.isAnonymous()) {
            return;
        }

        try {
            let required_value = videoStream.fullscreen ? 'blur(10px)' : 'blur(5px)';
            if(this.videoElement.style.filter !== required_value) {
                this.videoElement.style.filter = required_value;
            }
        } catch(e) {

        }
    }

    sendingTokens(value) { 
        this.setState({sendingTokens: value}); 
    }

    closeDonatPanel(giveTokenTimer) {
        this.setState({donatePanelShow: false});
        this.giveTokenTimer = giveTokenTimer;
    }

    cancelSendingTokens() {
        clearTimeout(this.giveTokenTimer);
        this.sendingTokens(0);
    }

    dragEnd(event, pointer) {
        if (this.props.popStream) {
            this.props.dispatch({type:"FULLSCREEN_POP_MOVE", left:this.videoWindow.style.left, top:this.videoWindow.style.top});
        }
    }

    componentDidMount() {
        this.videoElement.controls = false;

        let {browser, videoStream, currentUser} = this.props;

        if (browser.desktop) {
            this.draggabilly = new Draggabilly(this.videoWindow, {
                //handle: ".video",
                containment: document.body
            });
            this.draggabilly.on('dragEnd', this.dragEnd.bind(this));
            let videoWindow = this.videoWindow;
            VirtualWindowManager.register(this.videoWindow, this.props.videoStream.streamer.uid, this.draggabilly);
        }

        if (videoStream.windowState === VIDEO_WINDOW_STATE_PAUSED) {
            this.setPaused(this.props);
        }

        if (videoStream.stream && !this.state.currentUserBlocked) {
            this.videoElement.srcObject = videoStream.stream;
        }

        if (currentUser.isAnonymous()) {
            this.checkAnonymousBlurInterval = window.setInterval(this.checkAnonymousBlur, 2000);
        }

        this.videoWindow.addEventListener('mousemove', e => this.mouseMoveEvent());
        this.videoWindow.addEventListener('mouseleave', e => this.mouseLeaveEvent());

        this.videoElement.addEventListener('loadeddata', e => this.updateResolution());
        this.updateResolutionInterval = window.setInterval(this.updateResolution, 10000);

        this.setState({
            savedLeft: this.videoWindow.style.left,
            savedTop: this.videoWindow.style.top,
        });

        this.mouseLeaveEvent();
    }

    updateResolution()
    {
        let {videoStream} = this.props;

        if(videoStream.stream) {

            let media_stream_track = videoStream.stream.getVideoTracks()[0]; //MediaStreamTrack
            if( (media_stream_track instanceof MediaStreamTrack) && (typeof media_stream_track.getSettings === "function") ) {
                let videostream_settings = media_stream_track.getSettings();

                if (videostream_settings.width && videostream_settings.height) {
                    let resolution = videostream_settings.width + "x" + videostream_settings.height;
                    //console.log("resolution:", resolution);
                    this.setState({
                        resolution: resolution
                    });
                }

            }
        }
    }

    mouseMoveEvent() {
        const {
            browser,
            videoStream
        } = this.props;

        clearTimeout(this.timerMouseMove);

        $(this.videoWindow).find('.fade-effect').css({'opacity': 1});
        !videoStream.fullscreen || browser.mobile ? $(this.videoWindow).find('.background-dark').css({'opacity': 0.5}) : false;

        this.timerMouseMove = setTimeout(() => this.hidePanelEffect(), 2000);
    }

    mouseLeaveEvent() {
        clearTimeout(this.timerMouseMove);
        this.timerMouseMove = setTimeout(() => this.hidePanelEffect(), 500);
        //this.hidePanelEffect();
    }

    hidePanelEffect() {
        if(!this.state.sendingTokens) $(this.videoWindow).find('.fade-effect, .background-dark').css({'opacity': 0});
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.getBaseState(nextProps));

        if (this.props.behaviour == "floating" && nextProps.behaviour != "floating") {
            this.setState({
                savedLeft: this.videoWindow.style.left,
                savedTop: this.videoWindow.style.top,
                savedZIndex: this.videoWindow.style.zIndex
            });
        }

        if (nextProps.fullscreenStream && !this.props.fullscreenStream) {
            this.setState({
                fullscreen: true
            });
        }

        if (!nextProps.fullscreenStream && this.props.fullscreenStream) {
            this.setState({
                fullscreen: false
            });
        }

        if (nextProps.popStream && !this.props.popStream) {
            this.setState({
                pop:true
            });
        }

        if (!nextProps.popStream && this.props.popStream) {
            this.setState({
                pop:false
            });
        }

        if (this.props.videoStream.hitagi_stream.audio && !nextProps.videoStream.hitagi_stream.audio) {
            this.setState({
                savedSoundState: this.state.soundState,
                soundState: 'no_sound'
            });
        }

        if (!this.props.videoStream.hitagi_stream.audio && nextProps.videoStream.hitagi_stream.audio) {
            this.setState({
                soundState: this.state.savedSoundState
            });
        }

        let {currentUser, videoStream} = nextProps;
        this.setState({currentUserBlocked: currentUser.isBeingBlocked(videoStream.user)});

        if (!currentUser.isAnonymous()) {
            window.clearInterval(this.checkAnonymousBlurInterval);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        // todo: introduce VideoWindowGeneric component and fullscreen/collapse code there
        if (this.props.behaviour != "floating" && nextProps.behaviour == "floating") {
            this.videoWindow.style.left = this.state.savedLeft;
            this.videoWindow.style.top = this.state.savedTop;
            this.videoWindow.style.zIndex = this.state.savedZIndex;
        }

        let {browser, videoStream} = nextProps;

        if (!this.state.fullscreen && nextState.fullscreen) {
            this.videoWindow.style.left = "0px";
            this.videoWindow.style.top = "0px";
            this.videoWindow.style.zIndex = "";
        }

        if (this.state.fullscreen && !nextState.fullscreen) {
            if (browser.mobile) {
                this.videoContainer.style.top = "";
                this.videoContainer.style.width = "";
                this.videoContainer.style.height = "";
                this.videoContainer.style.transform = "";
            }
        }

        if (!this.state.pop && nextState.pop) {
            this.videoWindow.style.zIndex = "";

            this.videoContainer.style.transform = '';
            this.videoContainer.style.top = '';
            this.videoWindow.style.left = "";
            this.videoWindow.style.top = "";    

            this.videoWindow.style.left = this.props.fullscreenSettings.picture_in_picture_left;
            this.videoWindow.style.top = this.props.fullscreenSettings.picture_in_picture_top;
        }

        if (this.state.size !== nextState.size) {
            this.resizeVideoWindow(nextState.size);
        }
        
        if (nextState.soundState == 'mute' || nextState.soundState == 'no_sound') {
            this.videoElement.volume = 0.0;
            this.videoElement.muted = true;
        } else if (nextState.soundState == 'sound') {
            this.videoElement.volume = 1.0;
            this.videoElement.muted = false;
        }

        if (!this.props.videoStream.windowState != videoStream.windowState && videoStream.windowState == VIDEO_WINDOW_STATE_PAUSED) {
            this.setPaused(nextProps);
        }

        const checkUnmoved = this.state.unmoved &&
                            this.state.savedLeft &&
                            this.state.savedTop &&
                            !nextState.fullscreen &&
                            this.videoWindow.style.left !== this.state.savedLeft && 
                            this.videoWindow.style.top !== this.state.savedTop;

        if (checkUnmoved) this.setState({unmoved: false});
    }

    changeStatePanelMood() {
        this.setState({donatePanelShow: false})

        $('.mood').toggleClass('hide show');
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.fullscreen && this.state.fullscreen) {
            this.onWindowResizeFullscreen();
        }

        if (prevState.fullscreen && this.state.fullscreen && prevProps.browser.landscape != this.props.browser.landscape) {
            this.onWindowResizeFullscreen();
        }

        var sameStream = this.videoElement.srcObject == this.props.videoStream.stream;
        var userBlocked = this.state.currentUserBlocked;
        
        if (!sameStream && !userBlocked) {
            this.videoElement.srcObject = this.props.videoStream.stream;
        }
    }

    componentWillUnmount() {
        let {browser}  = this.props;

        if (this.checkAnonymousBlurInterval) {
            window.clearInterval(this.checkAnonymousBlurInterval);
        }

        if (this.updateResolutionInterval) {
            window.clearInterval(this.updateResolutionInterval);
        }

        if (browser.desktop) {
            VirtualWindowManager.unregister(this.videoWindow);
            this.draggabilly.destroy();
        }
    }

    render() {
        let lang = Registry.get('locale');

        let { 
            sendingTokens,
            donatePanelShow,
            videoWindowHeight,
            notEnoughTokensShow
        } = this.state;

        let {videoStream, currentUser, watcherCount, browser} = this.props,
            user = videoStream.user;
        watcherCount = videoStream.hitagi_stream.watcher_count;

        let cssClasses = [];

        if (videoStream.fullscreen) {
            cssClasses.push('fullscreen')
        } else {
            cssClasses.push('window');
            cssClasses.push('virtual-window');
        }

        if (videoStream.pop) {
            cssClasses.push('fullscreen-pop')
        }

        if (currentUser.isAnonymous()) {
            cssClasses.push('anonymous');
        }

        let windowStateClass = VideoWindow.mapWindowStateToCssClass[videoStream.windowState] || '';
        if (windowStateClass) cssClasses.push(windowStateClass);

        // todo: move to VirtualWindow component
        if (this.state.untouched) {
            cssClasses.push(VirtualWindowManager.VIDEO_WINDOW_UNTOUCHED_CLASS);
        }

        if (this.state.unmoved) {
            cssClasses.push(VirtualWindowManager.VIDEO_WINDOW_UNMOVED_CLASS);
        }

        cssClasses.push(this.state.size);

        donatePanelShow ? cssClasses.push('donate-panel-show') : false;

        let stubBlock = "",
            paused = false,
            isBlocked = false;

        switch (videoStream.windowState) {
            case VIDEO_WINDOW_STATE_CONNECTING:
            case VIDEO_WINDOW_STATE_CONNECTED:
                stubBlock = <div className="stub-block"><span className="stub-block-text opening-text">{lang.opening_video}</span></div>;
                break;
            case VIDEO_WINDOW_STATE_BLOCKED:
                isBlocked = true;
                stubBlock = (
                    <div className="stub-block">
                        <span className={"stub-block-text blocked-text" + (this.state.currentUserBlocked.type ? ' type-' + this.state.currentUserBlocked.type : '')}
                            dangerouslySetInnerHTML={{__html: lang.message_me_blocked(user)}}></span>
                    </div>
                ); break;
            case VIDEO_WINDOW_STATE_PAUSED:
                paused = true;
                stubBlock = (
                    <div className="stub-block" ref={(ref) => this.pausedStub = ref}>
                        <span className="stub-block-text paused-text">{lang.message_video_paused}</span>
                        <img src="" ref={(img) => this.pausedImg = img}/>
                    </div>
                ); break;
            case VIDEO_WINDOW_STATE_OFFLINE:
                stubBlock = (
                    <div className="stub-block">
                        <span className="stub-block-text offline-text">{lang.message_user_offline}</span>
                    </div>
                ); break;
            case VIDEO_WINDOW_STATE_LIMIT_REACHED:
                stubBlock = (
                    <div className="stub-block">
                        <span className="stub-block-text limit-reached-text" dangerouslySetInnerHTML={{__html: lang.message_limit_reached}}/>
                    </div>
                ); break;
            case VIDEO_WINDOW_STATE_ONLINE:
            default:
                if (currentUser.isAnonymous()) {
                    stubBlock = (
                        <div className="stub-block">
                            <span className="stub-block-text anonymous-text">
                                <a onClick={this.onRegisterClick}>{lang.message_please_register}</a>
                            </span>
                        </div>
                    );
                }
                break;
        }

        // Updating poster causes replacement of the video with the poster image on iOS so as an ugly fix let's make it not updating on iOS
        let isiOS = /iP(ad|hone)/i.test(navigator.userAgent);
        let cacheBuster = !isiOS ? "?_=" + Math.floor(Date.now() / 60000) : "";
        let poster = videoStream.thumbnail && !isBlocked ? videoStream.thumbnail + cacheBuster : '';

        return (
            <div className={'popup-video ' + cssClasses.join(' ')} ref={(videoWindow) => { this.videoWindow = videoWindow }} onClick={this.onClick}>
                <div className="video" ref={(ref) => this.videoContainer = ref}>
                    <div className="background-dark" style={sendingTokens ? {opacity: 0.5} : null}/>
                    {sendingTokens ? 
                        <div className="sending-jetons">
                            <div className="jetons-msg">
                                <div className="icon-vector"/>
                                <div className="text">{sendingTokens > 1 ? sendingTokens + lang.sending_tokens : sendingTokens + lang.sending_token}</div>
                            </div>
                            <div className="cancel" onClick={() => this.cancelSendingTokens()}>{lang.cancel}</div>
                        </div> 
                    : null }
                    <div className="top">
                        <div className="fono"></div>
                        <div className="counter">
                            <span className="eye"></span>
                            <span className="count">{watcherCount}</span>
                        </div>
                        <div className="text fade-effect">
                            {user.nick}
                        </div>
                        <div className="close fade-effect" onClick={this.onCloseClick}></div>
                    </div>
                    {this.state.resolution ? <div className="res fade-effect">{this.state.resolution}</div> : null}
                    {stubBlock}
                    <video
                           autoPlay="autoplay"
                           playsInline={true}
                           width={videoStream.width}
                           height={videoStream.height}
                           ref={(videoElement) => { this.videoElement = videoElement }}
                           onCanPlay={this.onVideoCanplay}
                           onContextMenu={this.onVideoContextMenu}
                           poster={poster}
                    />

                    {(!currentUser.isAnonymous() && !user.isAnonymous()) && (!stubBlock || paused) && user.nick !== currentUser.nick ? 
                        <a className="icon-donate fade-effect" onClick={() => 
                            this.setState({donatePanelShow: !donatePanelShow})
                        }/> 
                    : null}
                    {(!stubBlock || paused) && donatePanelShow ? 
                        <DonatePanel
                            user={user}
                            currentUser={currentUser}
                            sendingTokens={(value) => this.sendingTokens(value)}
                            onClose={(giveTokenTimer) => this.closeDonatPanel(giveTokenTimer)}
                        />
                    : null}
                    {(!stubBlock || paused) && user.mood ? 
                        <MoodPanel
                            user={user}
                            fullscreen={videoStream.fullscreen}
                            currentUser={currentUser}
                            close={() => this.changeStatePanelMood()} 
                            sendingTokens={(value) => this.sendingTokens(value)}
                            notEnoughTokensPopupShow={() => this.setState({notEnoughTokensShow: true})}
                        /> 
                    : null}
                    {!stubBlock && notEnoughTokensShow ? 
                        <NotEnoughTokens 
                            close={() => this.setState({notEnoughTokensShow: !notEnoughTokensShow})}
                        />
                    : null}

                    <div className="icon-block fade-effect" unselectable="on">
                        <a className={'sound-control ' + this.state.soundState} onClick={this.onSoundControlClick}></a>
                        {(!currentUser.isAnonymous() && !user.isAnonymous()) && 
                            <a className={`envelope ${user.pm_enabled || currentUser.isAdmin() ? '' : 'disabled'}`} onClick={() => user.pm_enabled || currentUser.isAdmin() ? UserContextMenu.pm(user, currentUser) : false}></a>
                        }
                        {!user.isAnonymous() &&
                            <a href={lang.path + user.getProfileURL()} target="_blank" className="user"></a>
                        }
                        <a className={'size-switch '+this.state.size} onClick={this.sizeSwitch}></a>
                        {(!currentUser.isAnonymous() && !user.isAnonymous()) && (!stubBlock || paused) && videoStream.fullscreen && user.mood ? 
                            <a className="icon-mood fade-effect" onClick={() => this.changeStatePanelMood()}/> 
                        : null}
                        <a className="fullscreen" onClick={() => this.fullscreen()}></a>
                        <a className="collapse" onClick={() => this.collapse()}></a>
                    </div>
                </div>
            </div>
        )
    }

}

VideoWindow.mapWindowStateToCssClass = {
    [VIDEO_WINDOW_STATE_OPENED]: null,
    [VIDEO_WINDOW_STATE_PAUSED]: 'paused',
    [VIDEO_WINDOW_STATE_BLOCKED]: 'blocked',
    [VIDEO_WINDOW_STATE_CONNECTING]: 'opening',
    [VIDEO_WINDOW_STATE_CONNECTED]: 'opening',
    [VIDEO_WINDOW_STATE_OFFLINE]: 'offline',
    [VIDEO_WINDOW_STATE_ONLINE]: 'online',
    [VIDEO_WINDOW_STATE_LIMIT_REACHED]: 'limit-reached'
};

export default VideoWindow;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/VideoWindow/index.js